module.exports = __webpack_public_path__ + "static/media/loader-de-resultados2---mobile.bc2c956b.gif";